// ============================================================
//  SCROLL SUAVE
// ============================================================
function smoothScrollTo(targetY, duration = 800) {
  const startY = window.scrollY;
  const distance = targetY - startY;
  if (Math.abs(distance) < 1) return;
  const startTime = performance.now();

  function step(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = progress < 0.5
      ? 2 * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 2) / 2;
    window.scrollTo(0, startY + distance * ease);
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

// ============================================================
//  NAVBAR SCROLL
// ============================================================
const navbar = document.getElementById('navbar');
window.addEventListener('scroll', () => {
  navbar?.classList.toggle('scrolled', window.scrollY > 60);
});

// ============================================================
//  PAGE TRANSITION
// ============================================================
document.body.classList.add('page-transition');
window.addEventListener('load', () => document.body.classList.add('page-loaded'));

document.addEventListener('click', function(e) {
  const link = e.target.closest('a');
  if (!link) return;
  const href = link.getAttribute('href');
  if (!href) return;
  if (href.startsWith('#') || href.startsWith('javascript:') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
  if (link.target === '_blank') return;
  
  const url = new URL(href, window.location.origin);
  if (url.origin !== window.location.origin) return;
  
  // NOVA REGRA: Se o link for uma âncora para a PÁGINA ATUAL, aborta o ecrã branco!
  if (url.pathname === window.location.pathname && url.hash !== '') return;

  if (document.body.classList.contains('page-leaving')) return;
  e.preventDefault();
  document.body.classList.add('page-leaving');
  setTimeout(() => window.location.href = href, 400);
});

// ============================================================
//  HAMBURGER & MOBILE MENU
// ============================================================
const hamburger = document.getElementById('hamburger');
const navLinks = document.getElementById('navLinks');

// Função auxiliar para fechar o menu e devolver o scroll
function fecharMenu() {
  if (!navLinks.classList.contains('open')) return;
  navLinks.classList.remove('open');
  hamburger.classList.remove('active');
  hamburger.setAttribute('aria-expanded', 'false');
  document.body.style.overflow = ''; // Devolve o scroll à página
}

if (hamburger && navLinks) {
  // Abrir / Fechar no botão Hamburger
  hamburger.addEventListener('click', (e) => {
    e.stopPropagation(); // Impede que este clique feche o menu imediatamente
    const isOpen = navLinks.classList.toggle('open');
    hamburger.classList.toggle('active');
    hamburger.setAttribute('aria-expanded', isOpen);
    
    // Bloqueia o scroll se abrir, desbloqueia se fechar
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  // Fechar menu ao clicar num dos links
  document.querySelectorAll('.nav-links a').forEach(link => {
    link.addEventListener('click', fecharMenu);
  });

  // Fechar menu ao clicar em qualquer lado fora dele (no fundo)
  document.addEventListener('click', (e) => {
    // Verifica se o menu está aberto e se o clique NÃO foi dentro do menu nem no botão
    if (navLinks.classList.contains('open') && !navLinks.contains(e.target) && !hamburger.contains(e.target)) {
      fecharMenu();
    }
  });
}

// ============================================================
//  BACK TO TOP
// ============================================================
const backTop = document.getElementById('backTop');
window.addEventListener('scroll', () => {
  backTop?.classList.toggle('visible', window.scrollY > 600);
});
backTop?.addEventListener('click', () => smoothScrollTo(0, 900));

// ============================================================
//  SCROLL ANIMATIONS (fade-up)
// ============================================================
const fadeEls = document.querySelectorAll('.fade-up');
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) entry.target.classList.add('visible');
  });
}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
fadeEls.forEach(el => observer.observe(el));

// ============================================================
//  SMOOTH ANCHOR SCROLL
// ============================================================
// NOVO SELECTOR: Apanha os links normais ("#") e os do teu menu ("/#")
document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const url = new URL(this.href);
    
    // Se o clique vier de outra página (ex: do carrinho para a home), deixa mudar de página normalmente
    if (url.pathname !== window.location.pathname) return;

    const targetId = url.hash;
    if (!targetId || targetId === '#') return;
    
    const target = document.querySelector(targetId);
    if (target) {
      e.preventDefault();
      const offset = 80;
      const targetY = target.getBoundingClientRect().top + window.pageYOffset - offset;
      smoothScrollTo(targetY, 800);
    }
  });
});


// ============================================================
//  LIGHTBOX
// ============================================================
const lightbox = document.getElementById('meu-lightbox');
const lightboxImg = document.getElementById('lightbox-imagem');
const lightboxDescricao = document.getElementById('lightbox-descricao');
const botaoFechar = document.querySelector('.lightbox-fechar');
const setaAnterior = document.querySelector('.lightbox-anterior');
const setaSeguinte = document.querySelector('.lightbox-seguinte');

let imagensGaleria = [];
let indiceAtual = 0;

function atualizarLightbox(indice) {
  if (!imagensGaleria.length) return;

  indiceAtual = (indice + imagensGaleria.length) % imagensGaleria.length;

  const img = imagensGaleria[indiceAtual];
  lightboxImg.src = img.getAttribute('src');
  lightboxImg.alt = img.getAttribute('alt') || 'SM CandleWithLove';
  lightboxDescricao.textContent = img.getAttribute('alt') || 'SM CandleWithLove';
}

function fecharLightbox() {
  lightbox?.classList.remove('mostrar');
  document.body.style.overflow = '';
  setTimeout(() => lightboxImg?.setAttribute('src', ''), 400);
}

function abrirLightbox(img) {
  imagensGaleria = Array.from(
    document.querySelectorAll('.gallery-item img')
  );

  const indice = imagensGaleria.indexOf(img);

  if (indice !== -1) {
    indiceAtual = indice;
  } else {
    imagensGaleria = [img];
    indiceAtual = 0;
  }

  atualizarLightbox(indiceAtual);
  lightbox?.classList.add('mostrar');
  document.body.style.overflow = 'hidden';
}

document.querySelectorAll('.gallery-item img, #mainImage').forEach(img => {
  img.addEventListener('click', function() {
    abrirLightbox(this);
  });
});

setaAnterior?.addEventListener('click', (e) => {
  e.stopPropagation();
  atualizarLightbox(indiceAtual - 1);
});

setaSeguinte?.addEventListener('click', (e) => {
  e.stopPropagation();
  atualizarLightbox(indiceAtual + 1);
});

botaoFechar?.addEventListener('click', fecharLightbox);

lightbox?.addEventListener('click', (e) => {
  if (e.target === lightbox) fecharLightbox();
});

document.addEventListener('keydown', (e) => {
  if (!lightbox?.classList.contains('mostrar')) return;

  if (e.key === 'Escape') fecharLightbox();
  if (e.key === 'ArrowLeft') atualizarLightbox(indiceAtual - 1);
  if (e.key === 'ArrowRight') atualizarLightbox(indiceAtual + 1);
});

// ============================================================
//  PESQUISA (overlay)
// ============================================================
const searchToggle = document.getElementById('searchToggle');
const searchOverlay = document.getElementById('searchOverlay');
const searchClose = document.getElementById('searchClose');
const searchForm = document.getElementById('searchForm');

function fecharOverlay() {
  searchOverlay?.classList.remove('active');
  document.body.style.overflow = '';
}
function abrirOverlay() {
  searchOverlay?.classList.add('active');
  document.body.style.overflow = 'hidden';
  const input = document.getElementById('searchQuery');
  if (input) input.focus();
}

searchToggle?.addEventListener('click', abrirOverlay);
searchClose?.addEventListener('click', fecharOverlay);
searchOverlay?.addEventListener('click', (e) => {
  if (e.target === searchOverlay) fecharOverlay();
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && searchOverlay?.classList.contains('active')) fecharOverlay();
});

// ============================================================
//  CARRINHO SHOPIFY (AJAX)
// ============================================================
function getCart() {
  return fetch('/cart.js')
    .then(res => res.json())
    .catch(() => ({ items: [] }));
}

function updateCartCount() {
  getCart().then(cart => {
    const total = cart.items.reduce((acc, item) => acc + item.quantity, 0);
    document.querySelectorAll('#cartCount').forEach(el => el.textContent = total);
  });
}

function mostrarToast(tipo, mensagem) {
  // Se receber apenas um argumento, assume que é a mensagem de sucesso
  if (mensagem === undefined) {
    mensagem = tipo;
    tipo = 'success';
  }

  let toast = document.getElementById('toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'toast';
    toast.className = 'toast';
    toast.innerHTML = `<i id="toastIcon" class="fas"></i><span id="toastMessage" style="margin-left: 10px;"></span>`;
    document.body.appendChild(toast);
  }

  const msgEl = document.getElementById('toastMessage');
  const iconEl = document.getElementById('toastIcon');

  // Forçar o texto
  if (msgEl) msgEl.innerText = mensagem;

  // Forçar o ícone e cor
  if (iconEl) {
    if (tipo === 'error' || tipo === 'errorToast') {
      iconEl.className = 'fas fa-exclamation-circle';
      toast.style.color = '#d9534f';
    } else {
      iconEl.className = 'fas fa-check-circle';
      toast.style.color = '#2c241e';
    }
  }

  toast.classList.add('show');
  
  clearTimeout(toast._timeout);
  toast._timeout = setTimeout(() => toast.classList.remove('show'), 3000);
}

// Adicionar ao carrinho (usado na página de produto)
function adicionarAoCarrinho(variantId, quantity) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
  })
    .then(res => res.json())
    .then(() => {
      updateCartCount();
      mostrarToast('Produto adicionado ao carrinho! 🛍️');
      // Redirecionar para o carrinho se desejar
      // window.location.href = '/cart';
    })
    .catch(err => {
      console.error(err);
      mostrarToast('Erro ao adicionar. Tente novamente.');
    });
}

// ============================================================
//  PÁGINA DE PRODUTO – Selector de quantidade e troca de imagem
// ============================================================

// Ouve as alterações diretas na caixa (se o cliente escrever com o teclado)
const qtyInput = document.getElementById('quantidade');
if (qtyInput) {
  // Dispara quando o cliente clica fora da caixa ou prime Enter
  qtyInput.addEventListener('change', function() {
    processarLimites(this, parseInt(this.value));
  });
  
  // Dispara enquanto o cliente está a digitar
  qtyInput.addEventListener('keyup', function() {
    // Só atua se a caixa não estiver vazia enquanto ele apaga/escreve
    if (this.value !== "") {
      processarLimites(this, parseInt(this.value));
    }
  });
}

// Controla os cliques nos botões + e -
window.alterarQuantidade = function(delta) {
  const input = document.getElementById('quantidade');
  if (!input) return;
  
  let valorAtual = parseInt(input.value) || 1;
  let novoValor = valorAtual + delta;
  
  processarLimites(input, novoValor);
};

// Função central (O "Cérebro" que verifica os limites)
function processarLimites(input, valorDesejado) {
  let min = parseInt(input.getAttribute('min')) || 1;
  
  // Lê o limite máximo (se a Shopify não injetar o max, assume infinito)
  let max = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : Infinity;
  
  // 1. Evita números inválidos ou abaixo de 1
  if (isNaN(valorDesejado) || valorDesejado < min) {
    input.value = min;
  } 
  // 2. Trava se exceder o stock e avisa o cliente
  else if (valorDesejado > max) {
    input.value = max; // Puxa logo o número de volta para o limite máximo
    
    // Usa o teu Toast bonito ou um Alerta normal
    if (typeof mostrarToast === 'function') {
      mostrarToast('errorToast', `Apenas temos ${max} unidade(s) disponível(eis) em stock.`);
    } else {
      alert(`Apenas temos ${max} unidade(s) disponível(eis) em stock.`);
    }
  } 
  // 3. Tudo OK, aceita o número
  else {
    input.value = valorDesejado;
  }
}

// Troca de imagem da galeria
window.changeImage = function(element) {
  document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
  element.classList.add('active');
  const main = document.getElementById('mainImage');
  if (!main) return;
  
  // Se por algum motivo falhar, usa o src normal como plano B.
  const newSrc = element.getAttribute('data-highres') || element.querySelector('img')?.getAttribute('src');
  
  if (newSrc) {
    main.setAttribute('src', newSrc);
    main.setAttribute('alt', element.querySelector('img')?.getAttribute('alt') || 'Produto SM');
  }
};

// ============================================================
//  PÁGINA DE PRODUTO – Botão de compra (usa window.productVariantId)
// ============================================================
document.querySelector('.product-actions .btn-gold')?.addEventListener('click', function(e) {
  e.preventDefault();
  const variantId = this.dataset.variantId || window.productVariantId;
  
  if (!variantId) {
    mostrarToast('errorToast', 'Erro: produto não identificado.');
    return;
  }
  
  const qty = parseInt(document.getElementById('quantidade')?.value || 1);
  adicionarAoCarrinho(variantId, qty);
});

// ============================================================
//  PÁGINA DE CARRINHO – renderização (usando cart.js)
// ============================================================
function renderizarCarrinho() {
  const container = document.getElementById('cartContainer');
  if (!container) return;
  getCart().then(cart => {
    if (cart.items.length === 0) {
      container.innerHTML = `
        <div class="empty-cart">
          <i class="fas fa-shopping-bag"></i>
          <h3>O seu carrinho está vazio</h3>
          <p>Que tal explorar a nossa coleção e levar algo especial?</p>
          <a href="/collections/all" class="btn btn-gold">Ver produtos</a>
        </div>
      `;
      return;
    }
    let html = `
      <div class="cart-table-wrap">
        <table class="cart-table">
          <thead>
            <tr><th>Produto</th><th>Preço</th><th>Quantidade</th><th>Subtotal</th><th></th></tr>
          </thead>
          <tbody>
    `;
    let totalGeral = 0;
    cart.items.forEach((item, index) => {
      const subtotal = item.price / 100 * item.quantity;
      totalGeral += subtotal;
      const imgSrc = item.image ? item.image : 'https://via.placeholder.com/60x60?text=SM';
      html += `
        <tr data-index="${index}">
          <td>
            <div class="item-info">
              <div class="item-image"><img src="${imgSrc}" alt="${item.title}" style="width:100%;height:100%;object-fit:cover;"></div>
              <span class="item-name">${item.product_title}</span>
            </div>
          </td>
          <td class="item-price">€${(item.price / 100).toFixed(2)}</td>
          <td>
            <div class="cart-qty">
              <button type="button" onclick="alterarQtdCart(${index}, -1)">−</button>
              <input type="number" id="qty-${index}" value="${item.quantity}" min="1" step="1" onchange="atualizarQtdCart(${index}, this.value)">
              <button type="button" onclick="alterarQtdCart(${index}, 1)">+</button>
            </div>
          </td>
          <td class="item-subtotal">€${subtotal.toFixed(2)}</td>
          <td><button class="btn-remove" onclick="removerItemCart(${index})"><i class="fas fa-trash-alt"></i></button></td>
        </tr>
      `;
    });
    html += `
          </tbody>
        </table>
      </div>
      <div class="cart-summary">
        <div class="total">Total: <span>€${totalGeral.toFixed(2)}</span></div>
        <div class="cart-actions">
          <a href="/collections/all" class="btn btn-outline"><i class="fas fa-arrow-left"></i> Continuar compras</a>
          <a href="/checkout" class="btn btn-gold"><i class="fas fa-check"></i> Finalizar compra</a>
        </div>
      </div>
    `;
    container.innerHTML = html;
  });
}

// ============================================================
//  PÁGINA DE CARRINHO – renderização e manipulação (AJAX)
// ============================================================

window.alterarQtdCart = function(index, delta) {
  getCart().then(cart => {
    const item = cart.items[index];
    if (!item) return;

    let novaQtd = item.quantity + delta;

    // AQUI ESTÁ A DIFERENÇA:
    if (novaQtd < 1) {
      // Se for menos de 1, removemos o item da Shopify (quantidade 0)
      removerItemCart(index);
    } else {
      // Se for 1 ou mais, apenas atualizamos a quantidade
      atualizarItemCart(index, novaQtd);
    }
  });
};

window.atualizarQtdCart = function(index, valor) {
  let novaQtd = parseInt(valor);
  if (isNaN(novaQtd) || novaQtd < 1) {
    novaQtd = 1;
    document.getElementById(`qty-${index}`).value = 1;
  }
  atualizarItemCart(index, novaQtd);
};

// FUNÇÃO CORRIGIDA: Esta é a que precisas de usar para remover
window.removerItemCart = function(index) {
  // Passamos 0 como quantidade para remover o item da Shopify
  atualizarItemCart(index, 0);
};

function atualizarItemCart(index, qtd) {
  // A Shopify utiliza 'line' (index + 1) para identificar a linha no carrinho
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: index + 1, quantity: qtd })
  })
    .then(res => {
      if (!res.ok) {
        return res.json().then(data => { throw new Error(data.description || 'Stock insuficiente'); });
      }
      return res.json();
    })
    .then(() => {
      renderizarCarrinho();
      updateCartCount();
      if(qtd === 0) {
        mostrarToast('success', 'Produto removido do carrinho.');
      } else {
        mostrarToast('success', 'Carrinho atualizado.');
      }
    })
    .catch(err => {
      console.error(err);
      mostrarToast('errorToast', err.message);
      renderizarCarrinho(); // Garante que a tabela volta ao estado real da Shopify
    });
}

// ============================================================
//  PESQUISA NA COLEÇÃO (filtro client‑side com URL)
// ============================================================
function inicializarPesquisa() {
  const searchInput = document.getElementById('searchInput');
  const clearBtn = document.getElementById('clearBtn');
  const productGrid = document.getElementById('productGrid');
  const noResults = document.getElementById('noResults');
  if (!searchInput || !productGrid) return;

  const urlParams = new URLSearchParams(window.location.search);
  const query = urlParams.get('q');
  if (query) {
    searchInput.value = query;
    setTimeout(() => filtrarProdutos(), 150);
  }

  const products = productGrid.querySelectorAll('.product-card');

  function filtrarProdutos() {
    const termo = searchInput.value.toLowerCase().trim();
    let encontrou = false;
    products.forEach(card => {
      const nome = (card.dataset.name || '').toLowerCase();
      const titulo = card.querySelector('.product-info h4')?.textContent?.toLowerCase() || '';
      const match = nome.includes(termo) || titulo.includes(termo);
      card.classList.toggle('hidden', !match);
      if (match) encontrou = true;
    });
    if (noResults) noResults.classList.toggle('show', !encontrou && termo.length > 0);
    if (clearBtn) clearBtn.classList.toggle('visible', termo.length > 0);
  }

  searchInput.addEventListener('input', filtrarProdutos);
  clearBtn?.addEventListener('click', function() {
    searchInput.value = '';
    filtrarProdutos();
    searchInput.focus();
    const url = new URL(window.location);
    url.searchParams.delete('q');
    window.history.replaceState({}, '', url);
  });
  searchInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      const term = this.value.trim();
      if (term) window.location.href = '/collections/all?q=' + encodeURIComponent(term);
      else window.location.href = '/collections/all';
    }
  });
}

// ============================================================
//  INICIALIZAÇÃO
// ============================================================
document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
  if (document.getElementById('cartContainer')) renderizarCarrinho();
  inicializarPesquisa();
});

// ============================================================
//  LÓGICA DAS VARIANTES DO PRODUTO E TROCA DE IMAGEM
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
  const dropdowns = document.querySelectorAll('.variant-dropdown');
  const masterSelect = document.getElementById('ProductSelect');
  const btnEncomendar = document.querySelector('.product-actions .btn-gold');
  const mainImage = document.getElementById('mainImage'); 
  
  const imagemPadrao = mainImage ? mainImage.getAttribute('src') : null;

  if (!dropdowns.length || !masterSelect || !btnEncomendar) return;

  function atualizarVariante() {
    const option0 = document.getElementById('Option-0')?.value || 'null';
    const option1 = document.getElementById('Option-1')?.value || 'null';
    const option2 = document.getElementById('Option-2')?.value || 'null';

    let selectedVariantId = null;
    let isAvailable = false;
    let variantImage = null;

    Array.from(masterSelect.options).forEach(opt => {
      const dOpt0 = opt.getAttribute('data-option0') || 'null';
      const dOpt1 = opt.getAttribute('data-option1') || 'null';
      const dOpt2 = opt.getAttribute('data-option2') || 'null';

      if (dOpt0 === option0 && dOpt1 === option1 && dOpt2 === option2) {
        selectedVariantId = opt.value;
        isAvailable = opt.getAttribute('data-available') === 'true';
        variantImage = opt.getAttribute('data-image');
      }
    });

    if (selectedVariantId) {
      // Atualiza o ID global para o botão "Encomendar" puxar a variante correta
      btnEncomendar.setAttribute('data-variant-id', selectedVariantId);
      window.productVariantId = selectedVariantId;

      if (isAvailable) {
        btnEncomendar.removeAttribute('disabled');
        btnEncomendar.style.opacity = '1';
        btnEncomendar.style.cursor = 'pointer';
        btnEncomendar.innerHTML = '<i class="fas fa-shopping-cart" style="margin-right:8px;"></i> Encomendar agora';
      } else {
        btnEncomendar.setAttribute('disabled', 'disabled');
        btnEncomendar.style.opacity = '0.5';
        btnEncomendar.style.cursor = 'not-allowed';
        btnEncomendar.innerHTML = '<i class="fas fa-times-circle" style="margin-right:8px;"></i> Esgotado';
      }
      
      // Controla a imagem principal e atualiza o seletor da miniatura
      if (mainImage) {
        // Define qual é a imagem que deve aparecer (a da variante ou a original)
        const targetImage = variantImage ? variantImage : imagemPadrao;
        
        if (targetImage) {
          // 1. Muda a imagem grande
          mainImage.src = targetImage;
          
          // 2. Muda a bordinha da miniatura
          document.querySelectorAll('.thumb').forEach(t => {
            t.classList.remove('active'); // Tira a borda de todas
            
            // Se o link de alta resolução da miniatura for igual à imagem da variante, mete a borda
            if (t.getAttribute('data-highres') === targetImage) {
              t.classList.add('active');
            }
          });
        }
      }
    }
  }

  // Escuta os cliques nas caixas de opções
  dropdowns.forEach(dropdown => {
    dropdown.addEventListener('change', atualizarVariante);
  });
  
  // Força uma verificação inicial mal a página carrega
  atualizarVariante();
});